const state = {
  modalInfo: {},
  m_dialogInfo: {
    obj: null,
    message: "",
    type: "",
    name: "",
    component: null
  },
  resultVal: false
};

const actions = {
  /* 모달 팝업 호출 */
  showModal({ state, commit }, modal) {
    commit("setModalParams", modal);
    let mWidth = modal.width;
    let mHeight = 'auto';

    if (modal.width !== undefined) {
      mWidth = modal.width;
    }
    if (modal.height !== undefined) {
      mHeight = modal.height;
    }

    modal.obj.show(
      modal.component,
      {
        modal: modal.obj,
        modalInfo: modal
      },
      {
        width: mWidth,
        height: mHeight
      }
    );
  },
  showDialog({ commit }, dialog) {
    commit("setDialogParams", dialog);
    let mWidth = "350px";
    let mHeight = 'auto';

    if (dialog.width !== undefined) {
      mWidth = dialog.width;
    }
    if (dialog.height !== undefined) {
      mHeight = dialog.height;
    }

    dialog.obj.show(
      dialog.component,
      {
        modal: dialog.obj,
        modalInfo : dialog
      },
      {
        width: mWidth,
        height: mHeight,
      }
    );
  },
  showToast(context, toast) { 
    // toast.message = toast.message.replace(/<(\/)?([a-zA-Z]*)(\s[a-zA-Z]*=[^>]*)?(\s)*(\/)?>/g,""); 
    toast.obj.show(toast.message, toast.options);
  },
  setResultVal({ commit }, resultVal) {
    commit("setResultVal", resultVal);
  }
};
const mutations = {
  setModalParams(state, modal) {
    state.modalInfo.name = modal.name;
    state.modalInfo.type = modal.type;
    state.modalInfo.value = modal.value;
    state.modalInfo.mWidth = modal.width;
    state.modalInfo.mHeight = modal.height;
    state.modalInfo.component = modal.component;
  },
  setDialogParams(state, dialog) {
    state.m_dialogInfo.message = dialog.message;
    state.m_dialogInfo.type = dialog.type;
    state.m_dialogInfo.name = dialog.name;
    state.m_dialogInfo.component = dialog.component;
  },
  setResultVal(state, resultVal) {
    state.resultVal = resultVal;
  }
};

const getters = {};

export default {
  state,
  actions,
  mutations,
  getters,
  namespaced: true
};



// WEBPACK FOOTER //
// ./src/js/store/module/common/modal.js